export default "__VITE_PUBLIC_ASSET__8c3a9e51__"